const BROAD_AREA_PLACE_TYPES = new Set([
    'country',
    'locality',
    'neighborhood',
    'plus_code',
    'postal_code',
])

const PRECISE_PLACE_TYPES = new Set([
    'establishment',
    'landmark',
    'point_of_interest',
    'premise',
    'route',
    'street_address',
    'subpremise',
])

const BROAD_AREA_PREFIXES = ['administrative_area_level_', 'sublocality']

const normalizePlaceTypes = (placeTypes: string[] = []): string[] =>
    placeTypes
        .filter(Boolean)
        .map((placeType) => placeType.trim().toLowerCase())

const hasBroadAreaPrefix = (placeType: string): boolean =>
    BROAD_AREA_PREFIXES.some((prefix) => placeType.startsWith(prefix))

export const isWideAreaPlaceSelection = (
    placeTypes: string[] = []
): boolean => {
    const normalizedPlaceTypes = normalizePlaceTypes(placeTypes)

    if (
        normalizedPlaceTypes.some((placeType) =>
            PRECISE_PLACE_TYPES.has(placeType)
        )
    ) {
        return false
    }

    return normalizedPlaceTypes.some(
        (placeType) =>
            BROAD_AREA_PLACE_TYPES.has(placeType) ||
            hasBroadAreaPrefix(placeType)
    )
}

export const getAddressPrecisionMetadata = (placeTypes: string[] = []) => {
    const normalizedPlaceTypes = normalizePlaceTypes(placeTypes)

    return {
        addressPrecisionRequired:
            isWideAreaPlaceSelection(normalizedPlaceTypes),
        addressPrecisionPlaceTypes: normalizedPlaceTypes,
    }
}
